<template> 
     <sidebar-item :link="{name: $t('EventLog'),  path: `/eventlog`,  icon: 'vip_icon icon_history'}">
     </sidebar-item>
</template>
<script>
    export default {
        name: 'CorpPolityMenu',
    }
</script>
